// extracted by mini-css-extract-plugin
module.exports = {"w15sfzy6":"w15sfzy6","l901flq":"l901flq"};